<template>
  <div id="app">
    <keep-alive>
			<router-view/>
		</keep-alive>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  background: #fff;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
</style>



// WEBPACK FOOTER //
// src/App.vue